import { useNavigate } from 'react-router-dom'
import Email from '../../assets/images/email.png'
import Phone from '../../assets/images/phone.png'
import Button from '../Button/Button'
import style from './Footer.module.scss'

const Footer = () => {
  const navigate = useNavigate()

  const handleTermsClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    navigate('/terms-and-conditions')
  }

  const handlePrivacyClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    navigate('/privacy-policy')
  }

  return (
    <footer className={style.footer}>
      <div className="container">
        <div className={style.footer__main}>
          {/* Company Info */}
          <article>
            <h4>Chauffeur Rides Ltd</h4>

            <a className={style.footer__main__item} href="tel:+447943152288">
              <img src={Phone} alt="phone" />
              <p>+44 7943152288</p>
            </a>

            <a className={style.footer__main__item} href="mailto:Chauffeurridesltd@hotmail.com">
              <img src={Email} alt="email" />
              <p>Chauffeurridesltd@hotmail.com</p>
            </a>

            <Button
              label="Contact Us"
              buttonType="white"
              extraClass={style.contactUsButton}
              onClick={() => navigate('/contact')}
            />
          </article>

          {/* Community */}
          <aside>
            <h4>Community</h4>
            <ol>
              <li>
                <a
                  href="https://www.instagram.com/chauffeurridesltd"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@chauffeur.rides.lt"
                  target="_blank"
                  rel="noreferrer"
                >
                  TikTok
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/share/1KdCw5uBJj/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </li>
            </ol>
          </aside>

          {/* Legal */}
          <aside>
            <h4>Legal</h4>
            <ol>
              <li>
                <button
                  type="button"
                  onClick={handleTermsClick}
                  className={style.footer__termsButton}
                >
                  Terms and Conditions
                </button>
              </li>

              <li>
                <button
                  type="button"
                  onClick={handlePrivacyClick}
                  className={style.footer__termsButton}
                >
                  Privacy and policy
                </button>
              </li>
            </ol>
          </aside>
        </div>

        <div className={`${style.footer__copyright} flex-wrap align-center justify-between`}>
          <p>©2024–2026 all rights reserved Chauffeur Rides</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
